import intl from 'react-intl-universal';

export const translate = (key: string, variables?: unknown): string => {
  return intl.get(key, variables);
};

export const translateHTML = (key: string, variables?: unknown): string => {
  return intl.getHTML(key, variables);
};
